import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject, takeUntil } from "rxjs";
import { AppFilter } from "app/models/app-filter.model";
import { AbUnidade } from "app/abstract/full-pages/unidade/unidade.abstract";

@Injectable({
    providedIn: 'root'
})
export class UnidadeService extends AbUnidade implements OnDestroy {

    unidades: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
    divisoes: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

    temUnidades: boolean;
    temDivisoes: boolean;

    unidadeReadOnly: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private readonly destroy$ = new Subject();

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public saveDivisoes(entity: any) {
        return super.save("divisoes/", entity);
    }

    public saveUnidades(entity: any) {
        return super.save("unidades/", entity);
    }

    public getAllDivisoes() {
        return this.get('divisoes/all/');
    }

    public getAllDivisoesPublic() {
        return this.get('public/divisoes/all/');
    }

    public getAllDivisoesFilter(filter: AppFilter) {
        return this.get('divisoes/filter/' + filter.encode());
    }

    public getAllUnidadesFilter(filter: AppFilter) {
        return this.get('unidades/filter/' + filter.encode());
    }

    public deleteDivisao(id: number) {
        return super.delete("divisoes/", id);
    }

    public getAllUnidades() {
        return this.get('unidades/all/');
    }

    public deleteAllDivisoes() {
        return this.http.delete(`${this.url}divisoes/delete/all`);
    }

    public verificarSeJaPossuiUnidades() {
        this.get("unidades/verificarsejapossuiunidades").pipe(takeUntil(this.destroy$)).subscribe((retorno: boolean) => {
            this.temUnidades = retorno;
        });
    }

    public verificarSeJaPossuiDivisoes() {
        this.get("divisoes/verificarsejapossuidivisoes").pipe(takeUntil(this.destroy$)).subscribe((retorno: boolean) => {
            this.temDivisoes = retorno;
        });
    }

    public getAllUnidadesByPessoa() {
        return this.get('unidades/unidade_pessoa/');
    }

    public getAllUnidadesByPessoaId(pessoaId) {
        return this.get(`unidades/unidade_pessoa/${pessoaId}`);
    }

    public getAllUnidadesByDivisoes(divisoesIds: any) {
        return this.get('unidades/unidade_divisoes/' + divisoesIds);
    }

    public atualizarStatusUnidade(pessoasId: number, unidadeId: number): Observable<any> {
        return this.save(`unidades/atualizar_situacao_unidade/${unidadeId}`, pessoasId);
    }

    public getUnidadesByDivisao(divisaoId: number) {
        return this.get(`public/unidades/unidade_divisao/${divisaoId}`);
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}